import { useContext } from 'react';

import { Notification } from '@savgroup-front-common/types';

import { MessageDescriptorMap } from '../../../../helpers';
import ToastsContext from '../ToastsProvider.context';

import usePushError, { UsePushErrorReturnType } from './usePushError';
import usePushErrors, { UsePushErrorsReturnType } from './usePushErrors';
import usePushNotification, {
  UsePushNotificationReturnType,
} from './usePushNotification';

interface UseToastsReturnValue {
  pushNotifications: (notifications: Notification[]) => void;
  pushNotification: UsePushNotificationReturnType;
  pushError: UsePushErrorReturnType;
  pushErrors: UsePushErrorsReturnType;
}

interface UseToastsArgs {
  extendedMessages?: MessageDescriptorMap;
}

const useToasts = ({
  extendedMessages,
}: UseToastsArgs = {}): UseToastsReturnValue => {
  const { pushNotifications } = useContext(ToastsContext);
  const pushNotification = usePushNotification();
  const pushError = usePushError({ extendedMessages });
  const pushErrors = usePushErrors({ extendedMessages });

  return {
    pushNotifications,
    pushNotification,
    pushError,
    pushErrors,
  };
};

export default useToasts;
